import React from "react";
import {
  AccountLevelContainer,
  BaseLevelIndicator,
  LevelContainer,
  TextContainer,
} from "./style";
export enum AccountLevelEnum {
  BRONZE = 1,
  PRATA = 2,
  OURO = 3,
}

interface Props {
  level: AccountLevelEnum;
  source?: "gov.br" | string;
}

const levelOptions = Object.values(AccountLevelEnum).map(Number).filter(Number);

const levelText = {
  [AccountLevelEnum.BRONZE]: "bronze",
  [AccountLevelEnum.PRATA]: "prata",
  [AccountLevelEnum.OURO]: "ouro",
};

// 🔹 Containers

interface LevelIndicatorProps {
  level: AccountLevelEnum;
  levelOption: number;
}

const LevelIndicator: React.FC<LevelIndicatorProps> = ({
  level,
  levelOption,
}) => {
  const filled = level >= levelOption;

  let backgroundColor = "var(--color-secondary)";

  if (level === AccountLevelEnum.BRONZE) {
    backgroundColor = "#f08080";
  } else if (level === AccountLevelEnum.PRATA) {
    backgroundColor = "#999999";
  } else if (level === AccountLevelEnum.OURO) {
    backgroundColor = "#ffcb07";
  }

  return (
    <BaseLevelIndicator
      sx={{
        ...(filled && { backgroundColor }),
      }}
    />
  );
};

export const AccountLevel: React.FC<Props> = ({
  level,
  source = "gov.br",
}: Props) => {
  return (
    <AccountLevelContainer>
      <LevelContainer>
        {levelOptions.map((levelOption) => (
          <LevelIndicator
            key={levelOption}
            level={level}
            levelOption={levelOption}
          />
        ))}
      </LevelContainer>
      <TextContainer>
        <p>
          Sua conta <strong>{source}</strong> é nível{" "}
          <strong>{levelText[level]}</strong>
        </p>
      </TextContainer>
    </AccountLevelContainer>
  );
};
